import "./site-header.css";

const SiteHeader = () => (
  <header className="site-header">
    <h1>NitroBolt Experiments</h1>
    <p>Testing zone for the big, upcoming features that we're working on!</p>
  </header>
);

export default SiteHeader;
